module.exports = __webpack_public_path__ + "static/media/INT.c84e9c1e.png";